export enum ProjectErrorCode {
  DUPLICATE_PROJECT_NUMBER = 1,
  DUPLICATE_EXTERNAL_PROJECT_ID = 2,
}
